<template>
    <div>

        <!-- {{lab_HIS_LIS_Mapping.hm}} -->
 
                 
                        <b-table 
                            :data="isEmpty ? [] : lab_HIS_LIS_Mapping.hm  "
                            bordered 
                            striped 
                            hoverable 
                            mobile-cards
                            :sticky-header="true"
                             :height="getHeightTbl"
                            >


                                    <b-table-column  label="Abbreviation"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).nick_name }}
                                    </b-table-column>

                                    <b-table-column  label="Parameter"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).full_name }}
                                    </b-table-column>

                                    <b-table-column  label="Value"  v-slot="props"   >
                                        
                                         <b-input 
                                                v-if="props.row.answer_1==0"
                                                type="number"
                                                v-model="props.row.val"
                                        ></b-input>

                                        <div v-else>
                                         <!-- {{props.row.answer_2_val}} -->
                                           <b-select placeholder="Select a name"
                                               v-model="props.row.val"
                                               >
                                                <option
                                                    v-for="option in props.row.answer_2"
                                                    :value="option"
                                                    :key="option">
                                                    {{ option }}
                                                </option>

                                                 
                                            </b-select>
                                           
                                               
                                            <b-button type="is-danger is-light"
                                                    v-if="props.row.val"
                                                    @click="props.row.val=null "
                                                    icon-right="delete" />  
                                    
                                            
                                        </div>

                                    </b-table-column>


                                     

                                    <b-table-column  label="Unit"  v-slot="props" >
                                       <b-input v-model="props.row.unit"  ></b-input> 
                                    </b-table-column>


                                    <b-table-column  label="Ref."  v-slot="props" >
                                       <b-input   v-model="props.row.ref"  ></b-input>
                                    </b-table-column>



                                    <b-table-column  label="Flag"  v-slot="props"  >
                                       <b-input v-model="props.row.flag"  ></b-input> 
                                    </b-table-column>

                                    <b-table-column  label="Machine ID"  v-slot="props"  >
                                       <b-input v-model="props.row.machine_id"  ></b-input> 
                                    </b-table-column>

 



                            <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                            </template>



                        </b-table>    
              
                            
 


    </div>
</template>


<script>
import { mapState} from "vuex";
import getNameFullnameFromFieldKey_CBC from '../../../mixins/methods/getNameFullnameFromFieldKey_CBC'

export default {
    name : "HematologyParam",
    mounted(){


        this.windowHeight = window.innerHeight;
            // console.log("Browser window height:", this.windowHeight);
        this.outerWindowHeight = window.outerHeight;
            // console.log("Full browser window height:", this.outerWindowHeight);
        // console.log("HematologyParam")
        // if(this.mode == 0){
        //    this.dataHM = this.lab_HIS_LIS_Mapping['hm']
        //    console.log(this.dataHM )
        // }else{
        //    // first thing first 
        //    // assign blank into every field   
        //    this.dataHM = this.lab_HIS_LIS_Mapping['hm'] //this.dataToEdit
        //    // update edit
        //     //    for(var i =0;i<=this.dataToEdit.length-1;i++){
        //     //      const tmp = this.dataHM.find(dat=>dat.field_name == this.dataToEdit[i].field_name)   
        //     //      if(tmp){
        //     //       tmp.val =  this.dataToEdit[i].val
        //     //       tmp.unit =  this.dataToEdit[i].unit
        //     //       tmp.ref =  this.dataToEdit[i].ref
        //     //       tmp.flag =  this.dataToEdit[i].flag
        //     //       tmp.machine_id =  this.dataToEdit[i].machine_id
        //     //      }
        //     //    }   

        // //      for(var i =0;i<=this.dataHM.length-1;i++){
        // //                 // clear all
        // //                 // keep param
        // //                 this.dataHM[i].val  = null
        // //                 this.dataHM[i].unit  = ""
        // //                 this.dataHM[i].ref  = "" 
        // //                 this.dataHM[i].flag   = ""
        // //                 this.dataHM[i].machine_id   = ""

        // //                 const tmp = this.dataToEdit_ManuallyLabAutomate.find(dat=>dat.field_name == this.dataHM[i].field_name)   
        // //                 if(!tmp){
        // //                 this.dataHM[i].val =  tmp.val
        // //                 this.dataHM[i].unit =  tmp.unit
        // //                 this.dataHM[i].ref =  tmp.ref
        // //                 this.dataHM[i].flag = tmp.flag
        // //                 this.dataHM[i].machine_id =  tmp.machine_id
        // //                 } 
        // //    } 

        // }
    },
     
    mixins:[getNameFullnameFromFieldKey_CBC,],
    computed:{
            ...mapState({
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,
                mapGroupName_From_Key : state => state.manually_create_lab_automate.mapGroupName_From_Key ,
                mapField_Fullname : state => state.manually_create_lab_automate.mapField_Fullname ,

                dataToEdit_ManuallyLabAutomate: state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate ,
            }),


            getHeightTbl(){
                return  this.windowHeight=='' ? 0 : this.windowHeight
            }
 
    },
    methods:{
        
      
    },
    data(){
        return {

               
               isEmpty : false,
          

               windowHeight : "",
               outerWindowHeight : ""

        }
    },
    

}
</script>

<style scoped>
  /* table , td {
  text-align: center;
}

  table , th {
 
  position: sticky;
 
} */
</style>